export const spacingBaseTokens = {
  "spacing.2xs": "2px",
  "spacing.xs": "4px",
  "spacing.sm": "8px",
  "spacing.md": "16px",
  "spacing.lg": "24px",
  "spacing.xl": "32px"
} as const;

export type SpacingToken = keyof typeof spacingBaseTokens;

export const getSpacingTokenValue = (token: SpacingToken): string => spacingBaseTokens[token];

export const radiusBaseTokens = {
  "radius.none": "0px",
  "radius.xs": "2px",
  "radius.sm": "4px",
  "radius.md": "8px",
  "radius.lg": "12px",
  "radius.xl": "16px",
  "radius.full": "9999px"
} as const;

export type RadiusToken = keyof typeof radiusBaseTokens;

export const getRadiusTokenValue = (token: RadiusToken): string => radiusBaseTokens[token];
